<template>
  <section :class="{ 'modal-backdrop': modalStore.modals.length }">
    <transition-group name="modal">
      <component
        :is="modal.component"
        v-for="(modal, index) in modalStore.modals"
        :key="modal.component.name"
        :close="modal.close"
        :dismiss="modal.dismiss"
        v-bind="modal.props"
        :class="{ 'd-block': modal.component, 'faded': index !== modalStore.modals.length - 1 }"
      />
    </transition-group>
  </section>
</template>

<script>
import Modal from './Modal.vue';
import {useModalStore} from "@/store/modal";
export default {
  setup() {
    const modalStore = useModalStore()

    return { modalStore }
  },
  components: { Modal },
}
</script>

<style lang="sass" scoped>
.modal-backdrop
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0, 0, 0, 0.3)
    display: flex
    justify-content: center
    align-items: center
    z-index: 100
    .faded
        opacity: .1
.modal-enter-active,.modal-leave-active
  transition: opacity .5s ease
.modal-enter,.modal-leave-to
  opacity: 0
</style>
